import { render, staticRenderFns } from "./send_processing.vue?vue&type=template&id=b571b47e&scoped=true"
import script from "./send_processing.vue?vue&type=script&lang=js"
export * from "./send_processing.vue?vue&type=script&lang=js"
import style0 from "./send_processing.vue?vue&type=style&index=0&id=b571b47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b571b47e",
  null
  
)

export default component.exports